module.exports = __webpack_public_path__ + "static/media/nBypSQd6Ux.967a6c33.jpg";